
























































































































import { JournalEntry } from "../../models/JournalEntry";
import moment from "moment";
import { Intervention } from "../../models/Intervention";
import { InterventionApi } from "../../api/InterventionApi";
import PhotosViewer from "../../core/Files/PhotosViewer.vue";
import EntryValidationCheckbox from "./EntryValidationCheckbox.vue";
import { User } from "../../models/User";
import { UserApi } from "../../api/UserApi";
import { Employe } from "../../models/Employe";
import JournalCommentStatusIndicator from "./JournalCommentStatusIndicator.vue";

export default {
    name: "InterventionStatus",
    components: {
        JournalCommentStatusIndicator,
        EntryValidationCheckbox,
        PhotosViewer,
    },
    props: {
        entry: JournalEntry,
    },
    data() {
        return {
            intervention: null,
            InterventionApi: new InterventionApi(),
            UserApi: new UserApi(),
            editable: false,
        };
    },
    created() {
        let self = this;

        self.UserApi.getCurrentUser().then(function (user) {
            self.editable = !user.hasRole(User.ERole.Syndic);
        });
    },
    computed: {
        datePriseEnCompte(): string {
            return this.entry.creation_date_str;
        },
        datePrevueIntervention(): string {
            let res = "";

            let date = moment(this.intervention.date_prevue_intervention);

            if (date.isValid()) {
                res =
                    '<i class="fal fa-check"></i> Intervention programmée le ' +
                    date.format("DD/MM/YYYY");
                if (this.intervention.horaire_debut) {
                    res += " à " + this.intervention.horaire_debut;
                }
            }

            return res;
        },
        ongoing(): boolean {
            return this.intervention.etat === Intervention.EEtat.Ongoing;
        },
        finished(): boolean {
            return (
                this.intervention.etat === Intervention.EEtat.Finished ||
                this.intervention.etat === Intervention.EEtat.Archived
            );
        },
    },
    methods: {
        sendBonDePassage(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.send_bon_de_passage,
                this.entry
            );
        },
        sendEmail(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.send_email,
                this.entry
            );
        },
        showIntervention(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.show_intervention,
                this.entry
            );
        },
        deleteEntry(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.delete_entry,
                this.entry
            );
        },
        openMails(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.show_mails,
                this.entry
            );
        },
        // UI
        employeList(): string {
            return _.chain(this.intervention.employes)
                .map(function (e: Employe) {
                    return e.fullName;
                })
                .join(", ")
                .value();
        },
    },
    watch: {
        entry: {
            immediate: true,
            handler: function () {
                let self = this;
                if (!this.entry.attachment || !this.entry.attachment.id) return;
                self.InterventionApi.get(this.entry.attachment.id, {
                    include: "photos",
                }).then(function (res) {
                    self.intervention = res;
                });
            },
        },
    },
};
